import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { PaymentsApi, RequestStrategyEnum } from '@shared/api';

interface UseDeleteRequisitesStore {
  loading: boolean;
  success: boolean | null;
  error: string | null;
  deleteRequisites: (id: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDeleteRequisitesStore = create<UseDeleteRequisitesStore>((set) => ({
  loading: false,
  error: null,
  success: null,

  deleteRequisites: ApiUtils.wrapperApi(async (id, signal) => {
    try {
      set({ loading: true, error: null, success: null });
      await PaymentsApi.deleteRequisites(id, signal);
      set({ loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null, success: null }),
}));
